import {Arr, Bool, Num, Obj, OptNum, Str} from '@repo/shared/api/core/api_schema';
import type {SchemaToType} from '@repo/shared/api/core/api_schema';

export const KohLantaVideoSchema = Obj({
  videoId: Str(),
  title: Str(),
  part: OptNum(),
  durationSeconds: OptNum(),
  bytes: OptNum(),
});
export type KohLantaVideo = SchemaToType<typeof KohLantaVideoSchema>;

export const KohLantaEpisodeSchema = Obj({
  episode: Num(),
  videos: Arr(KohLantaVideoSchema),
});
export type KohLantaEpisode = SchemaToType<typeof KohLantaEpisodeSchema>;

export const KohLantaSeasonSchema = Obj({
  id: Str(),
  label: Str(),
  season: OptNum(),
  episodes: Arr(KohLantaEpisodeSchema),
  latestEpisode: Num(),
});
export type KohLantaSeason = SchemaToType<typeof KohLantaSeasonSchema>;

export const KohLantaCatalogueSchema = Obj({
  enabled: Bool(),
  seasons: Arr(KohLantaSeasonSchema),
});
export type KohLantaCatalogue = SchemaToType<typeof KohLantaCatalogueSchema>;

export const TV_KOH_LANTA_API = {
  '/koh-lanta/catalogue': {POST: {req: Obj({}), res: KohLantaCatalogueSchema}},
  '/koh-lanta/playback': {POST: {req: Obj({videoId: Str()}), res: Obj({url: Str()})}},
};
